import React, { useEffect } from 'react'
import { ApiHit } from './Api/ApiHit'
import { dailyStatsCashRecord } from './Constant/Constant'
import { getSelectedAccount } from './Storage/Storage'

function Test() {
    useEffect(() => {
        getDailyData()
    }, [])
    const getDailyData = () => {
        let json ={
            page:1,
            limit:10,
            search :{
                accountId:getSelectedAccount()?._id
            }
        }
        ApiHit(json, dailyStatsCashRecord).then((res) => {
            console.log("res--", res);

        })
    }
    return (
        <div>
            Test
        </div>
    )
}

export default Test
